const API_PATH = '/api';

export async function fetch_read_more_items(guid){
	let response = await fetch(`${API_PATH}/page/${guid}/read-next/`)

	if (!response.ok) {
		throw "error while fetching";
	}

	return await response.json()
}

export async function fetch_top_projects(site_root){
	let response = await fetch(`${site_root}${API_PATH}/projects/selected/`)

	if (!response.ok) {
		throw "error while fetching";
	}

	return await response.json()
}

function guid_from_url(url) {
	try {
		let split = url.split('/');
		let guid = split[4];
		return guid;
	} catch (e) {
		return null;
	}	
}

export function get_page_guid() {	
	try {
		let canonical_url = document.querySelector("link[rel='canonical']").getAttribute('href');
		return guid_from_url(canonical_url);
	} catch (e) {
		return null;		
	}
}